module.exports = __webpack_public_path__ + "static/media/dnd.674baab1.svg";